module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3oLJYtn6wwAWeM46QYSaWy-29d3fa2e4af4152c98c11f48ae7da069.jpg";